const binding = { modules: {}, dataActions: {} };

    (binding.modules['defa-landing-page'] = {
        c: () => require('partner/modules/defa-landing-page/defa-landing-page.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'defa-landing-page',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/defa-landing-page'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|defa-landing-page|defa-landing-page'] = {
                c: () => require('partner/modules/defa-landing-page/defa-landing-page.view.tsx'),
                cn: '__local__-__local__-defa-landing-page'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };